/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */

import { useState } from 'react';
import { EventCard } from '../../../../components/EventCard/EventCard';
import { EventsFilterWidget } from '../../../../components/EventsFilterWidget/EventsFilterWidget';
import { Loader } from '../../../../components/Loader/Loader';
import { DropdownOption, IEventCard } from '../../../../types/types';
import Pagination from '../../../StaffPages/SupportList/Pagination';
import styles from './Events.module.scss';
import { useFetchEvents } from '../../../../hooks/useFetchEvents';

interface EventsProps {
    // пункт «Все» в фильтре актуальности — только в кабинете сотрудника
    withAllOption?: boolean;
}

export const Events = ({ withAllOption = false }: EventsProps) => {
    const [page, setPage] = useState<number>(1);

    const initialState = { value: '', label: 'Все' };
    const [format, setFormat] = useState<DropdownOption>(initialState);
    const [place, setPlace] = useState<DropdownOption>(initialState);
    const [isActual, setIsActual] = useState<boolean | null>(true);
    const [searchValue, setSearchValue] = useState<string>('');

    const {
        eventsData: events,
        isLoading,
        totalCount: paginationArr,
    } = useFetchEvents({
        page,
        size: 10,
        format: format.value || undefined,
        place: place.value || undefined,
        search: searchValue || undefined,
        isActual,
    });

    return (
        <div className={styles.EventsPage}>
            <EventsFilterWidget
                setFormat={setFormat}
                format={format}
                setPlace={setPlace}
                place={place}
                setSearchValue={setSearchValue}
                isActual={isActual}
                setIsActual={setIsActual}
                withAllOption={withAllOption}
            />

            {isLoading ? (
                <div className={styles.EventsPage__loader}>
                    <Loader />
                </div>
            ) : (
                <div className={styles.EventsPage__wrapper}>
                    <div className={styles.EventsPage__cards}>
                        {events && <EventsList events={events} />}
                    </div>
                </div>
            )}

            <Pagination
                list={{
                    page_count: paginationArr || 1,
                    current_page: page,
                }}
                handlePagination={(p) => setPage(p)}
                isLoading={isLoading}
            />
        </div>
    );
};

interface EventsListProps {
    events: IEventCard[];
}

export const EventsList = ({ events }: EventsListProps) => {
    return (
        <div className={styles.EventsList}>
            {events.map((event) => (
                <EventCard
                    event={event}
                    key={event.id}
                    containerClassName={styles.personalPage}
                    imageClassName={styles.personalPage__image}
                    titleClassName={styles.personalPage__title}
                    smallBlocksClassName={styles.personalPage__smallBlocks}
                />
            ))}
        </div>
    );
};
